import { Outlet, Navigate } from 'react-router-dom';

import AppDelegate from './AppDelegate';

const ProtectedRoute = () => {

  return (
    AppDelegate.user && AppDelegate.user.jwt ? <Outlet /> : <Navigate to="/login" />
  )

}

export default ProtectedRoute;